/**
 * Created by mateimisarca on 2019-06-07
 */

import InscrierePage from './inscriere-page';
export default InscrierePage;
